import * as React from 'react';
import { center, horizontal, vertical } from 'csstips';
import { classes, style } from 'typestyle';
import { em, important, px } from 'csx';
import { mediaMobileOnly } from '../theme/media';
import { transitionQuickEase } from '../theme/transition';
import { colorBackground, rebrand } from '../theme/color';

export interface PreferenceSelectorProps {
  title: string;
  subtitle: string;
  saving: boolean;
  disabled?: boolean;
  reducedOptions?: boolean;
}

export class PreferenceSelector extends React.Component<PreferenceSelectorProps, any> {
  render() {
    const { title, subtitle, children, disabled, reducedOptions } = this.props;
    return (
      <div className={classes(PreferenceSelector.styles.container, disabled && PreferenceSelector.styles.disabled)}>
        <div className={PreferenceSelector.styles.descriptionText}>
          <h2 className={PreferenceSelector.styles.title}>{title}</h2>
          <div className={PreferenceSelector.styles.subTitle}>{subtitle}</div>
        </div>
        <form className={PreferenceSelector.styles.form} onSubmit={this.handleSubmit}>
          {children}
        </form>
      </div>
    );
  }

  handleSubmit = (event: React.FormEvent<any>) => event.preventDefault();

  static styles = {
    container: style(
      {
        ...horizontal,
        transition: `color ${transitionQuickEase}`,
        backgroundColor: rebrand.neutralOnDark[10].toString(),
        border: `1px solid ${rebrand.contrast[10].toString()}`,
        borderRadius: px(8),
        width: '100%',
        maxWidth: px(992),
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: px(24),
        $nest: {
          '&> div:first-child': {
            flex: 1,
            lineHeight: em(1.4),
          },
          '&> div:first-child > div:first-child': {
            fontWeight: 'bold',
          },
          '&> form': {
            ...horizontal,
            justifyContent: 'flex-end',
            flex: 1,
          },
          '&> form label': {
            paddingLeft: px(18),
            paddingBottom: px(10),
          },
        },
      },
      mediaMobileOnly({
        ...vertical,
      })
    ),
    formNarrow: style({
      $nest: {
        '&> form': {},
      },
    }),
    form: style(
      mediaMobileOnly({
        marginTop: px(12),
      }),
      {
        width: '100%',
      }
    ),
    disabled: style({
      color: important(colorBackground.toString()),
    }),
    descriptionText: style(mediaMobileOnly({ margin: px(12) }), {
      margin: px(24),
      flex: 1,
    }),
    title: style(mediaMobileOnly({ fontSize: px(18) }), {
      margin: '8px 0',
      fontSize: px(28),
    }),
    subTitle: style(mediaMobileOnly({ fontSize: px(12) }), {
      fontSize: px(20),
      color: rebrand.contrast[40].toString(),
    }),
  };
}
